import Vue from 'vue'
import Router from 'vue-router'

import layout from '../layout'
import store from '../store'

Vue.use(Router)


// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
    /*
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          savedPosition
        });
      }, 1000);
    });
    */
  } else {
    return {x: 0, y: 0}
  }
}


let router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  base: '/',
  scrollBehavior,
  routes: [
    {
      path: '/',
      component: layout,
      meta: { 
        requiresAuth: true
      },
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () => import('@/pages/dashboard')
        }
      ]
    },

    {
      path: '/locations',
      component: layout,
      meta: { 
        requiresAuth: true
      },
      children: [

        {
          path: 'location-customer/:uid',
          name: 'location-customer',
          component: () => import('@/pages/locations/location_customer')
        },
        {
          path: 'location/:uid',
          name: 'location-detail',
          component: () => import('@/pages/locations/location')
        },
        {
          path: '',
          name: 'locations',
          component: () => import('@/pages/locations') 
        }
      ]
    },

    {
      path: '/billings',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '',
          name: 'billings',
          component: () => import('@/pages/billings')
        }
      ]
    },

    {
      path: '/settings',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '',
          name: 'settings',
          component: () => import('@/pages/settings')
        }
      ]
    },



    {
      path: '/login',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '',
          name: 'login',
          component: () => import('@/pages/login') 
        }
      ]
    },


   
    {
      path: '/error-pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'error-404',
          name: 'error-404',
          component: () => import('@/pages/samples/error-pages/error-404')
        },
        {
          path: 'error-500',
          name: 'error-500',
          component: () => import('@/pages/samples/error-pages/error-500')
        }
      ]
    },
   
    {
      path: '*',
      redirect: '/error-404',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'error-404',
          component: () => import('@/pages/samples/error-pages/error-404')
        }
      ]
    }
  ],
})



router.beforeEach((to, from, next) => {
  //next() 
  //return
  if(to.matched.some(record => record.meta.requiresAuth)) {
    //console.log("store.getters.authStatus",  store.getters.authStatus)
    //console.log(store.state.token)
    if (store.getters.authStatus) {
      next()
      return
    }
    next('/login') 
  } else {
    next() 
  }
})


export default router